import { Defaults } from '@pbt/pbt-ui-components'

export const setInitialItemQueryParam = (index?: number) => {
  if (index !== undefined) {
    // We're manually adjusting the index here because the top items get covered up by the header after scrolling down
    const adjustedIndex = Math.max(index - 3, 0)
    const url = new URL(window.location.href)
    url.searchParams.set('initialItem', adjustedIndex.toString())
    window.history.replaceState(
      { ...window.history.state, as: url.href, url: url.href },
      '',
      url.href,
    )
  }
}

// - If initialItemParam exists and bi-directional scroll is enabled:
//   - If calculated offset (initialItemParam - batchSize) is less than 10, use 0
//   - Otherwise use max(initialItemParam - batchSize, 0)
// - Default to 0 if conditions not met
export const getExpandedWidgetOffset = (
  initialItemParam: number | undefined,
  supportBiDirectionalInfiniteScroll: boolean,
) =>
  initialItemParam && supportBiDirectionalInfiniteScroll
    ? Math.max(initialItemParam - Defaults.INFINITE_LIST_BATCH_LOAD_COUNT, 0) <
      10
      ? 0
      : Math.max(initialItemParam - Defaults.INFINITE_LIST_BATCH_LOAD_COUNT, 0)
    : 0

export const getExpandedWidgetLimit = (
  initialItemParam: number,
  supportBiDirectionalInfiniteScroll: boolean,
) =>
  initialItemParam && supportBiDirectionalInfiniteScroll
    ? Defaults.INFINITE_LIST_BATCH_LOAD_COUNT * 2
    : Defaults.INFINITE_LIST_BATCH_LOAD_COUNT
